// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const zIndex: Styleguide["zIndex"] = {};

export default zIndex;
